<script lang="ts" setup>
  withDefaults(
    defineProps<{
      aspectRatio?: number | string
      borderRadius?: number | string
      animated?: boolean
      backgroundColor?: string
    }>(),
    {
      aspectRatio: 'auto',
      borderRadius: '0px',
      animated: true,
      backgroundColor: 'var(--color-secondary-paper-light)'
    }
  )
</script>

<template>
  <ion-skeleton-text
    :animated="animated"
    :style="{ aspectRatio, backgroundColor, borderRadius }"
    class="g-skeleton-image"
  />
</template>

<style lang="scss" scoped>
  ion-skeleton-text {
    margin: 0;
    --background-rgb: var(--color-skeleton-animation-overlay-rgb);
  }
</style>
